<template>
	<!-- COMPONENTE DEPRECATED - custom-dashboard-v2.vue ahora maneja todo de forma autónoma -->
	<!-- Este archivo se conserva solo como referencia hasta su eliminación completa -->
	<div class='tw-flex-col tw--mx-16'>
		<!-- Header oculto - custom-dashboard-v2 tiene su propio header -->
		<title-header v-if="false" class=" tw-mb-3">
			<v-layout row wrap justify-space-between align-center>
				<v-layout row wrap justify-start align-center>
					<v-flex xs3 tw-mx-2>
						<label :style="`color:${$appColors.success}`">
							Seleccione el Área
							<v-select
								label="Área"
								class="select-core"
								hide-details
								:menu-props="{ contentClass: 'type-select-content' }"
								height="37"
								autocomplete
								clearable
								multiple
								outline
								single-line
								:items="groups"
								item-text="name"
								item-value="id"
								return-object
								@input="getFilter('group', $event)"
							></v-select>
						</label>
					</v-flex>
					<v-flex xs3 tw-mx-2>
						<label :style="`color:${$appColors.success}`">
							Seleccione la Agencia
							<v-select
								label="Agencia"
								class="select-core"
								hide-details
								:menu-props="{ contentClass: 'type-select-content' }"
								height="37"
								autocomplete
								clearable
								multiple
								outline
								single-line
								:items="subsidiaries"
								item-text="name"
								item-value="id"
								return-object
								@input="getFilter('subsidiary', $event)"
							></v-select>
						</label>
					</v-flex>
				</v-layout>
				<div class="wrapper-btns">
					<v-btn color="primary btn-action" @click="goToBack">
						<img
							src="/static/img/icons/btn-right-arrow.webp"
							alt="Atrás"
							class="mr-4"
						/>
						Atrás
					</v-btn>
				</div>
			</v-layout>
		</title-header>

		<!-- DASHBOARD ANTIGUO - OCULTO (Referencia para futura eliminación) -->
		<div v-if="false" class="tw-flex tw-justify-between tw-gap-x-4">
			<div class="tw-w-2/3 tw-flex tw-flex-col">
				<div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-gap-4" v-if="!loading">
					<p-card class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full">
						<h3 :style="`color:${$appColors.secondary}`" class="headline">Evaluadores</h3>
						<h2 :style="`color:${$appColors.primary}`" class="tw-m-none tw-p-none">{{ evaluators.length }}</h2>
					</p-card>
					<p-card class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full">
						<h3 :style="`color:${$appColors.secondary}`" class="headline">Colaboradores</h3>
						<h2 :style="`color:${$appColors.primary}`" class="tw-m-none tw-p-none">{{ colaborators.length }}</h2>
					</p-card>
					<p-card class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full">
						<h3 :style="`color:${$appColors.secondary}`" class="headline">Hombres</h3>
						<h2 :style="`color:${$appColors.primary}`" class="tw-m-none tw-p-none">{{ maleFemale.male.length }} | {{ maleFemale.percentMale || 0 }}%</h2>
					</p-card>
					<p-card class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full">
						<h3 :style="`color:${$appColors.secondary}`" class="headline">Mujeres</h3>
						<h2 :style="`color:${$appColors.primary}`" class="tw-m-none tw-p-none">{{ maleFemale.female.length }} | {{ maleFemale.percentFemale || 0 }}%</h2>
					</p-card>
				</div>
				<div class="graphics tw-mt-4">
					<div class="graphics-item">
						<card-dashboard
							v-if="!loading && Object.keys(totalCompetences).length !== 0"
							:data-competences="totalCompetences"
							:height="627"
							title="Competencias"
							@show-graphic="showGraphicModal($event)">
						</card-dashboard>
					</div>
					<div class="graphics-item">
						<div class="graphics-2">
							<div class="graphics-2-item-2" v-for="(graphic, index) in dataGraphics" :key="index">
								<card-dashboard
									v-if="!loading"
									:data-competences="graphic"
									title="Competencias"
									@show-graphic="showGraphicModal($event)"
								>
								</card-dashboard>
							</div>
						</div>
					</div>
				</div>
				<div class="tw-flex tw-flex-col">
					<div class="tw-flex tw-w-full tw-justify-between tw-items-center tw-gap-1"
						v-for="(group, index) in dataRadarChart" :key="index">
						<div class="tw-flex tw-justify-end" style="min-width: 90px">
							<h3 v-if="!loading && dataRadarChart.length !== 0" :style="`color:${$appColors.primary}`">{{ group.name }}</h3>
						</div>
						<div class="graphics-radar">
							<div class="graphics-radar-item" v-for="(option, indexO) in group.options" :key="indexO">
								<card-dashboard
									v-if="!loading && dataRadarChart.length !== 0"
									:data-competences="option"
									:title="option.alternative"
									:height="150"
									:view="true"
									:width="'100%'"
									@show-graphic="showGraphicModal($event)">
								</card-dashboard>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tw-w-1/3">
				<card-dashboard
					v-if="!loading && Object.keys(jobsInProcess).length !== 0"
					:data-competences="jobsInProcess"
					:height="747"
					title="Puestos de Trabajo"
					@show-graphic="showGraphicModal($event)">
				</card-dashboard>
			</div>
		</div>
		<!-- FIN DASHBOARD ANTIGUO - OCULTO -->

		<!-- MODAL DASHBOARD ANTIGUO - OCULTO -->
		<v-dialog
			v-if="false"
			v-model="graphicModel"
			persistent
			max-width="850">
			<p-card class="tw-p-none overflow-hidden">
				<p-header-dialog :negative-margin="false" @closeClicked="closeModal()"></p-header-dialog>
				<card-dashboard-individual
					v-if="Object.keys(dataGraphicByModal).length !== 0"
					:data-competences="dataGraphicByModal"
					:view="true"
					title=""
					@show-graphic="showGraphicModal($event)">
				</card-dashboard-individual>
			</p-card>
		</v-dialog>
		<!-- FIN MODAL DASHBOARD ANTIGUO - OCULTO -->

		<!-- btn-float oculto - custom-dashboard-v2 maneja su propia interfaz -->
		<btn-float v-if="false" buttonText="Subir" />

		<!-- ============================================ -->
		<!-- DASHBOARD V2 - Componente autónomo -->
		<!-- ============================================ -->
		<custom-dashboard-v2
			:process-id="processId"
			:poll-id="pollId"
		></custom-dashboard-v2>
	</div>
</template>

<!-- SCRIPT - COMPONENTE DEPRECATED -->
<!-- Toda la lógica de carga de datos ha sido movida a custom-dashboard-v2.vue -->
<!-- Este archivo se conserva solo como referencia para futura eliminación -->
<script>
import titleHeader from '@/components/diagnosis/title-header';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import cardDashboard from '@/components/dashboard/card-dashboard';
import cardDashboardIndividual from '@/components/dashboard/card-dashboard-individual';
import btnFloat from '@/modules/evaluation-360/components/evaluation/btn-float';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import CustomDashboardV2 from '@/modules/evaluation-360/components/dashboard/custom-dashboard-v2';
import helper from '@/shared/helper';
import bus from '@/bus/app-bus';
import { MAIN_LOADER_EVENT } from '@/modules/shared/components/ui/p-main-loader.constants';

const { roundTo } = helper;

// Created deshabilitado - custom-dashboard-v2 ahora se encarga de cargar sus propios datos
function created() {
	// Datos cargados por custom-dashboard-v2 de forma autónoma
}

function loadCompetences() {
	return this.dataEvaluation.reduce((acc, item) => {
		const acum = [...acc];
		const find = acum.find(f => f.competenceName === item.competenceName);
		if (find) {
			const countFound = find.count;
			find.count = countFound + 1;
		} else {
			acum.push({
				competenceName: item.competenceName,
				count: 1,
			});
		}
		return acum;
	}, []).sort((a, b) => {
		const nameA = a.competenceName.toLowerCase();
		const nameB = b.competenceName.toLowerCase();
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}
		return 0;
	});
}

function loadCompetencesAlternatives() {
	return this.dataEvaluation.reduce((acc, item) => {
		const acum = [...acc];
		const index = acum.findIndex(f => f.alternative === item.alternative &&
			f.competenceName === item.competenceName);
		if (index !== -1) {
			const count1 = acum[index].count;
			acum[index].count = count1 + 1;
		} else {
			acum.push({
				alternative: item.alternative,
				competenceName: item.competenceName,
				count: 1,
			});
		}
		return acum;
	}, []).sort((a, b) => b.count - a.count);
}

function calculateStatistics(dataEv, key) {
	return dataEv.reduce((acc, item) => {
		const acum = [...acc];
		const index = acum.findIndex(f => f[key] === item[key]);
		if (index !== -1) {
			const count1 = acum[index].count;
			acum[index].count = count1 + 1;
			const add = acum[index].add;
			acum[index].add = add + item.avg;
			acum[index].avg = acum[index].add / acum[index].count;
		} else {
			acum.push({
				[key]: item[key],
				count: 1,
				add: item.avg,
				avg: item.avg,
				gender: item.gender,
			});
		}
		return acum;
	}, []);
}

async function loadData() {
	bus.$emit(MAIN_LOADER_EVENT, { show: true, message: 'Cargando Información...' });
	const { processId, pollId } = this.$route.params;
	const body = {
		pollId: Number(pollId),
		processId: Number(processId),
	};
	if (this.groupIds && this.groupIds.length > 0) {
		body.groupIds = this.groupIds.map(gi => gi.id);
	}
	const requests = [
		this.$httpPraktiko.get('groups'),
		this.$httpPraktiko.get('subsidiaries'),
		this.$httpPraktiko.post('dashboard/evaluation', body),
	];
	try {
		this.loading = true;
		[{ data: this.groups }, { data: this.subsidiaries }, { data: this.dataEvaluation }]
			= await Promise.all(requests);
		if (this.groupIds.length > 0) {
			const areaName = this.groupIds.map(a => a.name);
			this.dataEvaluation = this.dataEvaluation.filter(item => areaName.includes(item.area));
		}
		if (this.subsidiaryIds.length > 0) {
			const subsidiaryName = this.subsidiaryIds.map(a => a.name);
			this.dataEvaluation = this.dataEvaluation
				.filter(item => subsidiaryName.includes(item.subsidiary));
		}
		this.evaluators = this.calculateStatistics(this.dataEvaluation, 'evaluator');
		this.colaborators = this.calculateStatistics(this.dataEvaluation, 'colaborator');
		this.maleFemale = {
			male: this.colaborators.filter(f => f.gender === 'Masculino'),
			female: this.colaborators.filter(f => f.gender === 'Femenino'),
		};
		this.maleFemale.percentMale =
			roundTo((this.maleFemale.male.length * 100) / this.colaborators.length, 2);
		this.maleFemale.percentFemale =
			roundTo((this.maleFemale.female.length * 100) / this.colaborators.length, 2);
		const sortCompetences = this.loadCompetences().sort((a, b) => b.count - a.count);
		this.dataCompetences = {
			type: 'line',
			series: [
				{
					name: 'Competencias',
					data: this.loadCompetences().map(item => item.count),
				},
			],
			categories: this.loadCompetences().map(item => item.competenceName),
		};
		this.totalCompetences = {
			type: 'bar',
			series: [
				{
					name: 'Competencias',
					data: sortCompetences.map(item => item.count),
				},
			],
			categories: sortCompetences.map(item => item.competenceName),
		};
		const alternativePriority = {
			'Muy desarrollado': 0,
			Desarrollado: 1,
			'Medianamente desarrollado': 2,
			'Poco Desarrollado': 3,
		};
		const uniqueCompetences =
			[...new Set(this.loadCompetencesAlternatives().map(obj => obj.competenceName))];
		const alternatives = this.loadCompetencesAlternatives().sort((a, b) =>
			alternativePriority[a.alternative] - alternativePriority[b.alternative]);
		const uniqueAlternatives =
			[...new Set(alternatives.map(obj => obj.alternative))];
		this.competencesAlternatives = {
			type: 'area',
			series: uniqueAlternatives.reduce((acc, ua) => {
				const dataN = [];
				uniqueCompetences.forEach((uc) => {
					const itemN = this.loadCompetencesAlternatives().find(item =>
						item.competenceName === uc && item.alternative === ua);
					if (itemN) {
						dataN.push(itemN.count);
					} else {
						dataN.push(0);
					}
				});
				acc.push({ name: ua, data: dataN });
				return acc;
			}, []),
			categories: uniqueCompetences,
		};
		this.dataGraphics = [
			this.dataCompetences,
			this.competencesAlternatives,
		];
		// Data para gráfica puestos
		const dataJobs = this.jobCountsArray().sort((a, b) => a.count - b.count);
		this.jobsInProcess = {
			type: 'singlebar',
			series: [
				{
					data: dataJobs.map(j => j.count),
					name: 'Puestos de Trabajo',
				},
			],
			categories: dataJobs.map(j => j.job),
		};
		// Data para gráficos en Radar
		const competenciesFilter = this.colaboratorsCount();
		const order = [
			'Muy desarrollado',
			'Desarrollado',
			'Medianamente desarrollado',
			'Poco desarrollado',
		];
		const uniqueEvaluationGroups =
			[...new Set(competenciesFilter.map(item => item.evaluationGroup))];
		const uniqueAlternativesByGroup =
			[...new Set(competenciesFilter.map(item => item.alternative)
				.sort((a, b) => order.indexOf(a) - order.indexOf(b)))];
		const resultDataRadar = uniqueEvaluationGroups.map((group) => {
			const optionsCount = uniqueAlternativesByGroup
				.map(option => ({ type: 'radar', alternative: option, count: 0 }));
			competenciesFilter.forEach((item) => {
				if (item.evaluationGroup === group) {
					const optionIndex = uniqueAlternativesByGroup
						.findIndex(option => option === item.alternative);
					if (optionIndex !== -1) {
						optionsCount[optionIndex].count += 1;
					}
				}
			});
			return { name: group, options: optionsCount };
		});
		const resultWithTotal = resultDataRadar.map((item) => {
			const total = item.options.reduce((sum, option) => sum + option.count, 0);
			return { ...item, total };
		});
		this.dataRadarChart = this.makeDataRadar(resultWithTotal);
	} catch (error) {
		this.showGenericError();
	} finally {
		bus.$emit(MAIN_LOADER_EVENT, { show: false });
		this.loading = false;
	}
}

function jobCountsArray() {
	const jobCountMap = this.dataEvaluation.reduce((acc, item) => {
		acc[item.job] = (acc[item.job] || 0) + 1;
		return acc;
	}, {});
	return Object.entries(jobCountMap).map(([job, count]) => ({ job, count }));
}

function colaboratorsCount() {
	return this.dataEvaluation.map(item => ({
		evaluationGroup: item.evaluationGroup,
		alternative: item.alternative,
	}));
}

function makeDataRadar(array) {
	return array.map((item) => {
		const total = item.total;
		const optionsWithPorcentage = item.options.map((option) => {
			const porcentage = (option.count / total) * 100;
			return {
				...option,
				series: [roundTo(porcentage, 2)],
				categories: [option.alternative],
			};
		});
		return { ...item, options: optionsWithPorcentage };
	});
}

function goToBack() {
	const { processId } = this.$route.params;
	this.goTo('report-evaluation', { params: { id: processId } });
}

function showGraphicModal(grafic) {
	const newData = { ...grafic };
	if (newData.type === 'bar' || newData.type === 'singlebar') {
		newData.height = 745;
	}
	this.dataGraphicByModal = newData;
	this.graphicModel = true;
}

function closeModal() {
	this.graphicModel = false;
	this.dataGraphicByModal = {};
}

function getFilter(type, value) {
	if (type === 'group') {
		this.groupIds = value;
	} else if (type === 'subsidiary') {
		this.subsidiaryIds = value;
	}
	this.loadData();
}

const computed = {
	processId() {
		return this.$route.params.processId;
	},
	pollId() {
		return this.$route.params.pollId;
	},
};

function data() {
	return {
		dataEvaluation: [],
		groups: [],
		subsidiaries: [],
		dataGraphics: [],
		dataCompetences: {},
		totalCompetences: {},
		competencesAlternatives: {},
		jobsInProcess: {},
		dataRadarChart: [],
		loading: false,
		evaluators: [],
		colaborators: [],
		dataEvaCol: {
			evaluators: 0,
			colaborators: 0,
		},
		maleFemale: {
			male: 0,
			percentMale: 0,
			female: 0,
			percentFemale: 0,
		},
		groupIds: [],
		subsidiaryIds: [],
		graphicModel: false,
		dataGraphicByModal: {},
	};
}

export default {
	name: 'dashboard-evaluation',
	created,
	data,
	computed,
	components: {
		titleHeader,
		PCard,
		PButton,
		cardDashboard,
		cardDashboardIndividual,
		btnFloat,
		PHeaderDialog,
		'custom-dashboard-v2': CustomDashboardV2,
	},
	methods: {
		loadData,
		loadCompetences,
		calculateStatistics,
		loadCompetencesAlternatives,
		goToBack,
		jobCountsArray,
		colaboratorsCount,
		makeDataRadar,
		showGraphicModal,
		getFilter,
		closeModal,
	},
};
</script>

<style lang="scss" scoped>
.graphics {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	&-item {
		flex: 0 1 calc(50% - 0.5rem);
		margin-bottom: 1rem;
		box-sizing: border-box;
	}

}
.graphics-2 {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	&-item-2 {
		flex: 0 1 calc(50% - 0rem);
		margin-bottom: 1rem;
		box-sizing: border-box;
	}
}
.graphics-radar {
	display: flex;
	width: 85% !important;
	flex-wrap: nowrap;
	justify-content: space-between;
	gap: 5px;
	&-item {
		flex: 0 1 calc(25% - 0.3rem) !important;
		margin-bottom: 1rem;
		box-sizing: border-box;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/dashboard/evaluation.vue